// @ts-nocheck

import React from 'react';
import { CSSTransition } from 'react-transition-group';
import styled, { css, keyframes } from 'styled-components';

import { Target } from '../../client';
import ArrowButton from '../ArrowButton';

const DURATION = 300;

const appearAnim = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const disappearAnim = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const StyledArrowButton = styled(ArrowButton)`
  width: 2.5em;
  border-radius: 50em;
  background: #212121;
  color: white;
  transition: none 200ms ease-in-out;
  transition-property: filter, transform;
  border: 1px solid #313131;
  box-shadow: 0px 0px 3px white;
  font-size: 1.2em;
  opacity: 0.95;

  &.scrolltop-floating-button-transitions-enter {
    animation: ${appearAnim} ${DURATION}ms ease-out forwards;
  }
  &.scrolltop-floating-button-transitions-exit {
    animation: ${disappearAnim} ${DURATION}ms ease-out forwards;
  }

  ${!Target.__MOBILE__
    ? css`
        &:hover {
          background: #212121;
          color: white;
          filter: brightness(150%);
        }
      `
    : css`
        &:active {
          background: #212121;
          color: white;
          filter: brightness(150%);
        }
      `}
`;

type ScrollTopFloatingButtonProps = {
  className?: string;
  show?: boolean;
  onClick?: () => void;
};

const ScrollTopFloatingButton = ({
  className = '',
  show = false,
  onClick = () => {},
}: ScrollTopFloatingButtonProps) => {
  return (
    <CSSTransition in={show} timeout={DURATION} classNames="scrolltop-floating-button-transitions" unmountOnExit>
      <StyledArrowButton className={className} angle={270} onClick={onClick} disabled={!show} />
    </CSSTransition>
  );
};

export default ScrollTopFloatingButton;
